import RemoteJs from "../RemoteJs/index.vue";
export default {
  components: {
    RemoteJs
  },
  data() {
    return {};
  },
  mounted() {
    window.captchaCb = res => {
      console.log(res);
      // 返回结果
      // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
      // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
      // CaptchaAppId       String    验证码应用ID。
      // bizState    Any       自定义透传参数。
      // randstr     String    本次验证的随机串，请求后台接口时需带上。

      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（客户端出现异常错误 仍返回可用票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      if (res.ret === 0) {
        this.$emit("success", res);
      }
    };
  },
  unmounted() {
    window.__CaptchaExists__ = 0;
  },
  methods: {
    show() {
      this.$refs.CaptchaEl.click();
    }
  }
};